// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LocationSearch_wrapper__eNqIN","input":"LocationSearch_input__PvRPT","dropdown":"LocationSearch_dropdown__vs4Lk","focused":"LocationSearch_focused__BzU7N"};